<template>
  <v-content class="pa-12">
    <!-- Nevigater -->

    <!-- โครงการวิจัยที่ผ่านการพิจารณา -->
    <v-layout mb-12 v-if="this.$route.query.name === 'leader'">
      <v-flex shrink d-flex justify-start align-center class="nevigater-link"
        @click="$router.push('/research-approve-leader')">
        <span>โครงการวิจัยที่ผ่านการพิจารณา</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>ข้อมูลโครงร่างงานวิจัย</span>
      </v-flex>
    </v-layout>

    <!-- การประชุมทั้งหมด -->
    <v-layout mb-12 v-if="this.$route.query.name === 'meeting'">
      <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.push('/all-meeting')">
        <span>การประชุมทั้งหมด</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.go(-1)">
        <span>ข้อมูลการประชุม</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>ข้อมูลโครงร่างงานวิจัย</span>
      </v-flex>
    </v-layout>

    <!-- Post Approve -->
    <v-layout mb-12 v-if="this.$route.query.from === 'ViewDataPostApprove'">
      <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.push('/post-approve')">
        <span>Post Approve</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.go(-1)">
        <span>ดูข้อมูล</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>ข้อมูลโครงร่างงานวิจัย</span>
      </v-flex>
    </v-layout>

    <!-- research All -->
    <v-layout mb-12 v-if="this.$route.query.from === 'researchAll'">
      <v-flex shrink d-flex justify-start align-center class="nevigater-link" @click="$router.push('/all-research')">
        <span>งานวิจัยทั้งหมด</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>ดูข้อมูลโครงร่างงานวิจัย</span>
      </v-flex>
    </v-layout>

    <!-- โครงการวิจัยที่ผ่านการพิจารณา -->
    <v-layout mb-12 v-if="this.$route.query.from === 'VerifiedResearch'">
      <v-flex shrink d-flex justify-start align-center class="nevigater-link"
        @click="$router.push('/verified-research')">
        <span>โครงการวิจัยที่ผ่านการพิจารณา</span>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center>
        <v-icon color="#3E7662">arrow_right</v-icon>
      </v-flex>
      <v-flex shrink d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>ดูข้อมูลโครงร่างงานวิจัย</span>
      </v-flex>
    </v-layout>

    <!-- Start Form -->

    <v-card>
      <v-layout pa-8 justify-center style="background-color: #3E7662;">
        <v-flex style="text-align: left;">
          <span style="font-weight: bold;font-size: 28px;color: white;">แบบโครงร่างการวิจัย</span>
        </v-flex>
        <v-flex style="text-align: right;">
          <!--                    <span style="font-size: 14px;color: white;">Version……….Date…………………….</span><br>-->
          <span style="font-size: 14px;color: white;">RF 08_2_2563</span>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex px-12 py-6>

          <v-layout row align-center my-3 pl-4>
            <v-flex style="text-align: left;" shrink>
              <span style="font-weight: bold;font-size: 16px;">ประเภทการส่ง</span>
            </v-flex>
            <v-flex pl-4>
              <v-radio-group row v-model="submissionType">
                <v-radio color="#3E7662" label="Initial submission" value="0"></v-radio>
                <v-radio color="#3E7662" label="Re submission (Manual)" value="2"></v-radio>
                <v-radio color="#3E7662" label="Re submission" value="1"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex v-if="form.researchs.researchCode" row>
              <span class="mr-3">รหัสโครงการ*</span>
              <TextfieldForm :model="form.researchs.researchCode"
                @update-data="updateDataResearchs('researchCode', $event)"></TextfieldForm>
            </v-flex>
          </v-layout>
          <!-- choice 1 -->
          <v-layout>
            <v-flex style="text-align: left;">
              <span style="font-weight: bold;font-size: 16px;">1. ชื่อโครงการ</span>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex pt-2 style="text-align: left;">
              <span class="pl-3" style="font-weight: bold;font-size: 16px;color: #CC3D45;">*ภาษาไทย</span>
            </v-flex>
          </v-layout>
          <TextfieldForm :model="form.researchs.thResearchName"
            @update-data="updateDataResearchs('thResearchName', $event)"></TextfieldForm>

          <v-layout>
            <v-flex style="text-align: left;">
              <span class="pl-3" style="font-weight: bold;font-size: 16px;color: #CC3D45;">*ภาษาอังกฤษ</span>
            </v-flex>
          </v-layout>
          <TextfieldForm :model="form.researchs.enResearchName"
            @update-data="updateDataResearchs('enResearchName', $event)"></TextfieldForm>

          <!-- choice 1.1 -->
          <v-layout class="mt-6">
            <v-flex xs2 pt-2 style="text-align: left;">
              <span style="font-weight: bold;font-size: 16px;">1.1 Protocol No.(ถ้ามี)</span>
            </v-flex>
            <v-flex xs4 class="text-input">
              <TextfieldForm :model="form.researchs.protocolNumber"
                @update-data="updateDataResearchs('protocolNumber', $event)"></TextfieldForm>
            </v-flex>
          </v-layout>
          <v-layout class="mt-6">
            <v-flex xs2 pt-2 style="text-align: left;">
              <span style="font-weight: bold;font-size: 16px;">1.2 โครงร่างวิจัย CREC / YMID (ถ้ามี)</span>
            </v-flex>
            <v-flex xs4 class="text-input">
              <TextfieldForm :model="form.researchs.ymidtype" @update-data="updateDataResearchs('ymidtype', $event)">
              </TextfieldForm>
            </v-flex>
            <v-flex xs2 pt-2 style="text-align: left;" ml-3>
              <span style="font-weight: bold;font-size: 16px;">1.3 รหัสโครงร่างวิจัย CREC / YMID (ถ้ามี)</span>
            </v-flex>
            <v-flex xs4 class="text-input">
              <TextfieldForm :model="form.researchs.ymidname" @update-data="updateDataResearchs('ymidname', $event)">
              </TextfieldForm>
            </v-flex>
          </v-layout>
          <!-- choice 2 -->
          <v-layout>
            <v-flex shrink pt-2 pr-4 style="text-align: left;">
              <span style="font-weight: bold;font-size: 16px;">2. สาขาที่ทำการวิจัย</span>
            </v-flex>
            <TextfieldForm :model="form.researchs.field" @update-data="updateDataResearchs('field', $event)">
            </TextfieldForm>
          </v-layout>

          <!-- choice 3 -->
          <v-layout mb-4 mt-6>
            <v-flex shrink pt-2 pr-4 style="text-align: left;">
              <span style="font-weight: bold;font-size: 16px;">3. ผู้วิจัยร่วมและที่ปรึกษา</span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink style="text-align: left;" v-if="user_role === 1 && status === 'อนุมัติ'">
              <v-btn dark style="width: 80px;background-color: #3E7662" @click="add(1)">
                <v-icon>add</v-icon>
                <span class="font-weight-bold">เพิ่ม</span>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout mb-12>
            <v-flex>
              <div v-for="(input, k) in researchers" :key="k">
                <v-layout justify-space-between>
                  <v-flex xs4 class="field-select" v-if="input.position !== 'ผู้วิจัยหลัก'">
                    <v-select clearable label="ผู้ร่วมวิจัย / ที่ปรึกษา / ผู้ประสานงาน"
                      :menu-props="{ bottom: true, offsetY: true }" v-model="input.position" background-color="#3E7662"
                      solo flat dense :items="researcher_type" item-text="type" item-value="type"
                      :value-comparator="findMatchingProvince"></v-select>
                  </v-flex>
                  <v-flex xs4 class="field-select" v-else>
                    <TextfieldForm :model="input.position" @update-data="updateDataResearchs('position', $event)">
                    </TextfieldForm>
                  </v-flex>
                  <v-flex xs2 pt-2 mr-4 style="text-align: right;font-weight: bold;">
                    <span>ชื่อ-นามสกุล</span>
                  </v-flex>
                  <v-flex xs4 class="field-select">
                    <text-autocomplete id="province" :items="user_list" item-text="user_name" itemValue="user_id"
                      :model="input.userID" @update-data="
                        updateDataResearchers($event, k)
                        " />
                  </v-flex>
                  <v-flex xs2 class="d-flex justify-end">
                    <v-checkbox v-model="input.canManage" color="#3E7662" label="มีสิทธิ์แก้ไข">
                    </v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout mb-5>
                  <v-flex xs4></v-flex>
                  <v-flex xs2>
                    <p class="text-right">ประวัตินักวิจัย</p>
                  </v-flex>
                  <v-flex xs1 ml-4>
                    <v-btn color="#3E7662" :disabled="input.historyFilePath == '' || input.historyFilePath == null"
                      :dark="!(input.historyFilePath == '' || input.historyFilePath == null)"
                      @click="openPDF(input.historyFilePath, 1)">
                      <v-icon class="pr-3">cloud_download</v-icon>
                      <span>Download</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <!-- choice 4 -->
          <v-layout>
            <v-flex shrink style="text-align: left;">
              <DateInputForm :disabled="user_role !== 1 || status !== 'อนุมัติ'" :model="dateChange1"
                style="font-weight: bold" label="4. ระยะเวลาที่ทำการวิจัย เริ่ม"
                @update-data="updateDate('startDate', $event)"></DateInputForm>
            </v-flex>
            <v-flex shrink pl-12 style="text-align: right;">
              <DateInputForm :disabled="user_role !== 1 || status !== 'อนุมัติ'" :model="dateChange2"
                style="font-weight: bold" label="สิ้นสุด" @update-data="updateDate('endDate', $event)"></DateInputForm>
            </v-flex>
          </v-layout>

          <!-- choice 5 -->
          <v-layout class="mt-6">
            <v-flex xs6 pr-0 pb-6>
              <v-layout>
                <v-flex shrink pt-2 pr-4 style="text-align: left;">
                  <span style="font-weight: bold;font-size: 16px;">5.1 สถานที่ทำการวิจัย ภาษาไทย</span>
                </v-flex>
                <v-flex class="text-input">
                  <textarea-form :model="form.researchs.researchPlace"
                    @update-data="updateDataResearchs('researchPlace', $event)"></textarea-form>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- choice 5 -->
          <v-layout class="mt-6">
            <v-flex xs6 pr-0 pb-6>
              <v-layout>
                <v-flex shrink pt-2 pr-4 style="text-align: left;">
                  <span style="font-weight: bold;font-size: 16px;">5.2 สถานที่ทำการวิจัย ภาษาอังกฤษ</span>
                </v-flex>
                <v-flex class="text-input">
                  <textarea-form :model="form.researchs.researchPlaceEn"
                    @update-data="updateDataResearchs('researchPlaceEn', $event)">
                  </textarea-form>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <!--                     choice 6-->
          <v-layout>
            <v-flex class="text-start">
              <span style="font-weight: bold;font-size: 16px;">6. ชนิดของการศึกษา</span>
            </v-flex>
          </v-layout>
          <v-radio-group v-model="form.researchs.educationType">
            <v-layout>
              <v-flex xs4>
                <v-radio color="#3E7662" label="Laboratory study" value="Laboratory study">
                </v-radio>
                <v-radio color="#3E7662" label="Observational study" value="Observational study">
                </v-radio>
                <v-radio color="#3E7662" label="Experimental study (Clinical trial)"
                  value="Experimental study (Clinical trial)">
                </v-radio>
                <v-radio color="#3E7662" label="Medical record review" value="Medical record review">
                </v-radio>
              </v-flex>
              <v-flex xs4>
                <v-radio color="#3E7662" label="Registration" value="Registration">
                </v-radio>
                <v-radio color="#3E7662" label="แบบสอบถาม (Questionnaire)" value="แบบสอบถาม (Questionnaire)">
                </v-radio>
                <v-radio color="#3E7662" label="Case report" value="Case report">
                </v-radio>
                <v-layout>
                  <v-flex shrink class="d-flex align-center">
                    <v-radio color="#3E7662" label="อื่นๆ ระบุ" value="อื่นๆ ระบุ">
                    </v-radio>
                  </v-flex>
                  <v-flex pl-3>
                    <TextfieldForm hide-detail :disabled="form.researchs.educationType !== 'อื่นๆ ระบุ'"
                      :model="form.researchs.otherEducationType" @update-data="
                        updateDataResearchs('otherEducationType', $event)
                        "></TextfieldForm>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-radio-group>

          <!--Choice 7-->
          <v-layout>
            <v-flex class="text-start">
              <span style="font-weight: bold;font-size: 16px;">7. กลุ่มประชากร</span>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3>
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group1" label="ผู้ป่วย" />
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group2" label="หญิงตั้งครรถ์" />
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group3" label="เด็ก" />
              <v-layout>
                <v-flex shrink class="d-flex align-center">
                  <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group10" label="อื่นๆ ระบุ"
                    @change="clearTextField('otherSampleGroup')" />
                </v-flex>
                <v-flex pl-3 mt-3>
                  <TextfieldForm :disabled="!form.researchs.checkboxSampleGroup.group10"
                    :model="form.researchs.otherSampleGroup" @update-data="
                      updateDataResearchs('otherSampleGroup', $event)
                      "></TextfieldForm>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3>
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group4"
                label="พลเรือน(สุขภาพดี)" />
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group5" label="ทหาร" />
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group6" label="นักเรียนทหาร" />
            </v-flex>
            <v-flex xs3>
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group7" label="บุคลากรในสถาบัน" />
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group8" label="ชุมชน" />
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxSampleGroup.group9"
                label="ผู้บกพร่องทางสติปัญญา" />
            </v-flex>
          </v-layout>

          <!--Choice 8-->
          <v-layout>
            <v-flex class="text-start">
              <span style="font-weight: bold;font-size: 16px;">8. แหล่งทุนและงบประมาณในการวิจัย</span>
            </v-flex>
          </v-layout>
          <v-layout mx-8 mt-4 justify-space-between>
            <v-flex xs4 class="field-select">
              <!-- Color Select Input -->
              <v-select label="แหล่งทุน ภายนอก/ภายใน" :menu-props="{ bottom: true, offsetY: true }" v-model="isInside"
                background-color="#3E7662" solo flat dense :items="isInsideList" item-text="name" item-value="id"
                @change="getBudgetList()"></v-select>
              <v-select label="ชื่อแหล่งทุนวิจัย" :menu-props="{ bottom: true, offsetY: true }"
                v-model="form.researchs.budgetResourceID" :background-color="isInside == null ? '#C4C4C4' : '#3E7662'"
                solo flat dense :items="budget_list" item-text="budget_name" item-value="budget_id"
                :disabled="isInside == null"></v-select>
            </v-flex>

            <v-spacer></v-spacer>

            <v-flex ml-8 mr-3 shrink pt-2 style="color: #3E7662;font-weight: bold">
              <span>ยอดรวม</span>
            </v-flex>
            <v-flex xs4 d-flex justify-end>
              <TextfieldForm :model="form.researchs.budgetAmount"
                @update-data="updateDataResearchs('budgetAmount', $event)"></TextfieldForm>
            </v-flex>
            <v-flex ml-3 shrink pt-2 style="color: #3E7662;font-weight: bold">
              <span>บาท</span>
            </v-flex>
          </v-layout>

          <!--Choice 9-->
          <v-layout>
            <v-flex class="text-start">
              <span style="font-weight: bold;font-size: 16px;">9. รายการมีส่วนได้ส่วนเสีย (การที่บุคคลมีผลประโยชน์
                เป็นหุ้นส่วนของบริษัท หรือมีส่วนได้ส่วนเสียกับบริษัทยา)</span>
            </v-flex>
          </v-layout>

          <v-layout mt-6>
            <v-flex xs1></v-flex>
            <v-flex xs5>
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxInterestedGroup.interested1"
                @change="clearTextField('ownerAmount')" label="ผู้ถือหุ้นหรือเจ้าของกิจการ"
                :disabled="user_role !== 1 || status !== 'อนุมัติ'" />
              <v-checkbox color="#3E7662" v-model="form.researchs.checkboxInterestedGroup.interested2"
                @change="clearTextField('compensationAmount')"
                label="ค่าตอบแทน (นอกเหนือจากที่ได้รับจากงบประมาณการวิจัย)"
                :disabled="user_role !== 1 || status !== 'อนุมัติ'" />
              <v-layout>
                <v-flex shrink class="d-flex align-center">
                  <v-checkbox color="#3E7662" v-model="form.researchs.checkboxInterestedGroup.interested3"
                    @change="clearTextField('otherAmount')" label="อื่นๆ ระบุ"
                    :disabled="user_role !== 1 || status !== 'อนุมัติ'" />
                </v-flex>
                <v-flex ml-4 xs6 class="d-flex align-center">
                  <TextfieldForm hideDetail :disabled="!form.researchs.checkboxInterestedGroup.interested3
                    " :model="form.researchs.checkboxInterestedGroup.hasInterested3
                      " @update-data="($event) => {
                        form.researchs.checkboxInterestedGroup.hasInterested3 = $event;
                      }
                        "></TextfieldForm>
                </v-flex>
              </v-layout>

              <v-checkbox :disabled="user_role !== 1 || status !== 'อนุมัติ'" color="#3E7662"
                v-model="form.researchs.checkboxInterestedGroup.interested4" label="ไม่มี"
                @change="clearTextField('dontHaveAmount')" />
            </v-flex>
            <v-flex xs4>
              <v-layout mt-1>
                <v-flex mt-2 shrink>
                  <span>จำนวนเงิน</span>
                </v-flex>
                <v-flex px-2 xs6>
                  <TextfieldForm :disabled="!form.researchs.checkboxInterestedGroup.interested1
                    " type="number" :model="form.researchs.ownerAmount"
                    @update-data="updateDataResearchs('ownerAmount', $event)">
                  </TextfieldForm>
                </v-flex>
                <v-flex mt-2 shrink>
                  <span>บาท</span>
                </v-flex>
              </v-layout>
              <v-layout mt-1>
                <v-flex mt-2 shrink>
                  <span>จำนวนเงิน</span>
                </v-flex>
                <v-flex px-2 xs6>
                  <TextfieldForm :disabled="!form.researchs.checkboxInterestedGroup.interested2
                    " type="number" :model="form.researchs.compensationAmount" @update-data="
                      updateDataResearchs('compensationAmount', $event)
                      "></TextfieldForm>
                </v-flex>
                <v-flex mt-2 shrink>
                  <span>บาท</span>
                </v-flex>
              </v-layout>
              <v-layout mt-1>
                <v-flex mt-2 shrink>
                  <span>จำนวนเงิน</span>
                </v-flex>
                <v-flex px-2 xs6>
                  <TextfieldForm :disabled="!form.researchs.checkboxInterestedGroup.interested3
                    " type="number" :model="form.researchs.otherAmount"
                    @update-data="updateDataResearchs('otherAmount', $event)">
                  </TextfieldForm>
                </v-flex>
                <v-flex mt-2 shrink>
                  <span>บาท</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex xs6></v-flex>
            <v-flex xs4>
              <v-layout>
                <v-flex mt-2 shrink>
                  <span>รวมเป็นเงิน</span>
                </v-flex>
                <v-flex xs6 px-2>
                  <TextfieldForm :model="totalAmount"></TextfieldForm>
                </v-flex>
                <v-flex mt-2 shrink>
                  <span>บาท</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <!--File Upload-->
          <v-layout>
            <v-flex shrink class="text-start">
              <span style="font-weight: bold;font-size: 16px;">10. เอกสารที่ต้องส่ง</span>
            </v-flex>
            <v-flex pl-6 class="text-start">
              <span style="font-weight: bold;font-size: 12px;color: red">*หมายเหตุ: อัพโหลดได้เฉพาะไฟล์นามสกุล PDF
                เท่านั้น</span>
            </v-flex>
          </v-layout>
          <!--Initial-->
          <div v-if="form.researchs.version == 1 && form.researchs.isManual == 0">
            <!--Upload1-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือรับรองจากผู้บังคับบัญชาระดับ
                      ผอ.กอง หรือ
                      หัวหน้าภาควิชา*</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex xs7>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF1')" class="link-pdf">{{
                          namePDF1
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-layout>
                      <v-flex shrink class="text-start d-flex align-center">
                        <span class="font-weight-bold">เลขหนังสือ</span>
                      </v-flex>
                      <v-flex pl-2 class="mt-n4">
                        <v-text-field v-model="form.researchs.guarantyNumber" hide-details
                          color="3E7662"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload2-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารโครงร่างงานวิจัย (RF
                      08_2_2563)*</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF2')" class="link-pdf">{{
                          namePDF2
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload3-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือข้อตกลงรักษาความลับของข้อมูลฯ
                      (RO01_1_2563)*</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF3')" class="link-pdf">{{
                          namePDF3
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload4-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือข้อตกลงในการดำเนินการวิจัย
                      (RO01_2_2563)*</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;font-size: 16px;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF4')" class="link-pdf">{{
                          namePDF4
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload5-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารรับรองโครงร่างการวิจัย จาก
                      CREC/YMID</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF5')" class="link-pdf">{{
                          namePDF5
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span
                      style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา
                      (RF 01_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('onHaveSubmitReportForConsider')" class="link-pdf">{{
                          onHaveSubmitReportForConsider
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Other Upload-->
            <v-layout mt-6>
              <v-flex py-6>
                <v-layout>
                  <v-flex shrink pb-6 style="text-align: left;font-weight: bold">
                    <span style="font-weight: bold;font-size: 16px;">11. เอกสารอื่นๆ
                    </span>
                    <span style="color: #CC3D45;font-size: 12px">*หมายเหตุ : อัพโหลดได้เฉพาะไฟล์นามสกุล PDF
                      เท่านั้น</span>
                  </v-flex>
                </v-layout>
                <!--แบบบันทึกข้อมูล (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบบันทึกข้อมูล (ถ้ามี)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHavedataRecordFrom')" class="link-pdf">{{ onHavedataRecordFrom }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบสอบถามหรือสัมภาษณ์
                        (ถ้ามี)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveQuestionnaireInterview')" class="link-pdf">{{
                        onHaveQuestionnaireInterview }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--สมุดบันทึก (diary) (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">สมุดบันทึก (diary) (ถ้ามี)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDiary')" class="link-pdf">{{
                        onHaveDiary
                      }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา ภาษาไทย (Information sheet/consent)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span
                        style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย
                        /หนังสือแสดงเจตนา (RF 09_1_2563)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDocumentsExplain')" class="link-pdf">{{ onHaveDocumentsExplain
                        }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ เช่น วิดีโอ ซีดี เทป-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารอื่นๆ ได้แก่ โฆษณา
                        สิ่งตีพิมพ์
                        บทความ สื่อ เช่น
                        วิดีโอ ซีดี เทป</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveOtherDocuments')" class="link-pdf">{{ onHaveOtherDocuments }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--สำเนาหนังสือรับรองว่า ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">สำเนาหนังสือรับรองว่า
                        ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveCertificate')" class="link-pdf">{{ onHaveCertificate }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--คู่มือผู้วิจัย (Investigator brochure)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">คู่มือผู้วิจัย (Investigator
                        brochure)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveInvestigatorBrochure')" class="link-pdf">{{
                        onHaveInvestigatorBrochure
                      }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบประวัติผู้วิจัย-->
                <!--                <div class="mb-8">-->
                <!--                  <v-layout>-->
                <!--                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">-->
                <!--                      <span-->
                <!--                          style="font-weight: bold;font-size: 19px;color: #CC3D45;"-->
                <!--                      >แบบประวัติผู้วิจัย/ผู้ร่วมม/ที่ปรึกษา (RF 10_2563)</span-->
                <!--                      >-->
                <!--                    </v-flex>-->
                <!--                  </v-layout>-->
                <!--                  <v-layout pl-8>-->
                <!--                    <v-flex shrink pt-2 pr-4 style="text-align: left;">-->
                <!--                      <span style="font-weight: bold"-->
                <!--                      >ชื่อไฟล์ที่อัพโหลด :-->
                <!--                      </span>-->
                <!--                      <span-->
                <!--                          @click="openPDF('onHaveResearcherProfile')"-->
                <!--                          class="link-pdf"-->
                <!--                      >{{ onHaveResearcherProfile }}</span-->
                <!--                      >-->
                <!--                    </v-flex>-->
                <!--                  </v-layout>-->
                <!--                </div>-->
              </v-flex>
            </v-layout>
          </div>
          <!--Manual Re Submission(in active)-->
          <div v-if="form.researchs.version == 99 && form.researchs.isManual == 99">
            <!--Upload1-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือรับรองจากผู้บังคับบัญชาระดับ
                      ผอ.กอง หรือ
                      หัวหน้าภาควิชา*</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex xs7>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF1')" class="link-pdf">{{
                          namePDF1
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-layout>
                      <v-flex shrink class="text-start d-flex align-center">
                        <span class="font-weight-bold">เลขหนังสือ</span>
                      </v-flex>
                      <v-flex pl-2 class="mt-n4">
                        <v-text-field v-model="form.researchs.guarantyNumber" hide-details
                          color="3E7662"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload2-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารโครงร่างงานวิจัย(Clean
                      Version)
                      (RF 08_2_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF7')" class="link-pdf">{{
                          namePDF7
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารโครงร่างงานวิจัย(Highlight
                      Version) (RF 08_2_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF8')" class="link-pdf">{{
                          namePDF8
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload3-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือข้อตกลงรักษาความลับของข้อมูลฯ
                      (RO01_1_2563)*</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF3')" class="link-pdf">{{
                          namePDF3
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload4-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือข้อตกลงในการดำเนินการวิจัย
                      (RO01_2_2563)*</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;font-size: 16px;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF4')" class="link-pdf">{{
                          namePDF4
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload5-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารรับรองโครงร่างการวิจัย จาก
                      CREC/YMID</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF5')" class="link-pdf">{{
                          namePDF5
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload6-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบรายการแก้ไขโครงร่างวิจัย (RF
                      02_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF6')" class="link-pdf">{{
                          namePDF6
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload7-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารแสดงผลการพิจารณา (RL
                      02_1_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF13')" class="link-pdf">{{
                          namePDF13
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณาClean-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span
                      style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา
                      (RF 01_2563) Clean Version</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('onHaveSubmitReportForConsiderClean')" class="link-pdf">{{
                          onHaveSubmitReportForConsiderClean
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณาHighlight-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span
                      style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา
                      (RF 01_2563) Highlight Version</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('onHaveSubmitReportForConsiderHighlight')" class="link-pdf">{{
                          onHaveSubmitReportForConsiderHighlight
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Other Upload-->
            <v-layout mt-6>
              <v-flex py-6>
                <v-layout>
                  <v-flex shrink pb-6 style="text-align: left;font-weight: bold">
                    <span style="font-weight: bold;font-size: 16px;">11. เอกสารอื่นๆ
                    </span>
                    <span style="color: #CC3D45;font-size: 12px">*หมายเหตุ : อัพโหลดได้เฉพาะไฟล์นามสกุล PDF
                      เท่านั้น</span>
                  </v-flex>
                </v-layout>
                <!--แบบบันทึกข้อมูล (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบบันทึกข้อมูล (ถ้ามี) (Clean
                        Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHavedataRecordFromClean')" class="link-pdf">{{ onHavedataRecordFromClean
                        }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบบันทึกข้อมูล (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบบันทึกข้อมูล (ถ้ามี) (Highlight
                        Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHavedataRecordFromHighlight')" class="link-pdf">{{
                        onHavedataRecordFromHighlight }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)
                        (Clean
                        Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveQuestionnaireInterviewClean')" class="link-pdf">{{
                        onHaveQuestionnaireInterviewClean }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)
                        (Highlight Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="
                        openPDF('onHaveQuestionnaireInterviewHighlight')
                        " class="link-pdf">{{ onHaveQuestionnaireInterviewHighlight }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--สมุดบันทึก (diary) (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">สมุดบันทึก (diary) (ถ้ามี) (Clean
                        Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDiaryClean')" class="link-pdf">{{ onHaveDiaryClean }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--สมุดบันทึก (diary) (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">สมุดบันทึก (diary) (ถ้ามี)
                        (Highlight Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDiaryHighlight')" class="link-pdf">{{ onHaveDiaryHighlight }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา ภาษาไทย (Information sheet/consent)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span
                        style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย
                        /หนังสือแสดงเจตนา (Clean Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDocumentsExplainClean')" class="link-pdf">{{
                        onHaveDocumentsExplainClean }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา ภาษาไทย (Information sheet/consent)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span
                        style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย
                        /หนังสือแสดงเจตนา (Highlight Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDocumentsExplainHighlight')" class="link-pdf">{{
                        onHaveDocumentsExplainHighlight }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ เช่น วิดีโอ ซีดี เทป-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารอื่นๆ ได้แก่ โฆษณา
                        สิ่งตีพิมพ์
                        บทความ สื่อ เช่น
                        วิดีโอ ซีดี เทป</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveOtherDocuments2')" class="link-pdf">{{ onHaveOtherDocuments2
                        }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--สำเนาหนังสือรับรองว่า ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">สำเนาหนังสือรับรองว่า
                        ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveCertificate2')" class="link-pdf">{{ onHaveCertificate2 }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--คู่มือผู้วิจัย (Investigator brochure)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">คู่มือผู้วิจัย (Investigator
                        brochure)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveInvestigatorBrochure2')" class="link-pdf">{{
                        onHaveInvestigatorBrochure2 }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบประวัติผู้วิจัย-->
                <!--                <div class="mb-8">-->
                <!--                  <v-layout>-->
                <!--                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">-->
                <!--                      <span-->
                <!--                          style="font-weight: bold;font-size: 19px;color: #CC3D45;"-->
                <!--                      >แบบประวัติผู้วิจัย/ผู้ร่วมม/ที่ปรึกษา (RF 10_2563) (re submission)</span-->
                <!--                      >-->
                <!--                    </v-flex>-->
                <!--                  </v-layout>-->
                <!--                  <v-layout pl-8>-->
                <!--                    <v-flex shrink pt-2 pr-4 style="text-align: left;">-->
                <!--                      <span style="font-weight: bold"-->
                <!--                      >ชื่อไฟล์ที่อัพโหลด :-->
                <!--                      </span>-->
                <!--                      <span-->
                <!--                          @click="openPDF('onHaveResearcherProfile2')"-->
                <!--                          class="link-pdf"-->
                <!--                      >{{ onHaveResearcherProfile2 }}</span-->
                <!--                      >-->
                <!--                    </v-flex>-->
                <!--                  </v-layout>-->
                <!--                </div>-->
              </v-flex>
            </v-layout>
          </div>
          <!--Re Submission && Manual Re Submission-->
          <div v-if="form.researchs.version > 1 || (form.researchs.version == 1 && form.researchs.isManual == 1)">
            <!--Upload1-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือรับรองจากผู้บังคับบัญชาระดับ
                      ผอ.กอง หรือ
                      หัวหน้าภาควิชา*</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex xs7>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF1')" class="link-pdf">{{
                          namePDF1
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-layout>
                      <v-flex shrink class="text-start d-flex align-center">
                        <span class="font-weight-bold">เลขหนังสือ</span>
                      </v-flex>
                      <v-flex pl-2 class="mt-n4">
                        <v-text-field v-model="form.researchs.guarantyNumber" hide-details
                          color="3E7662"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload2-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารโครงร่างงานวิจัย(Clean
                      Version)
                      (RF 08_2_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF7')" class="link-pdf">{{
                          namePDF7
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารโครงร่างงานวิจัย(Highlight
                      Version) (RF 08_2_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF8')" class="link-pdf">{{
                          namePDF8
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload3-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือข้อตกลงรักษาความลับของข้อมูลฯ
                      (RO01_1_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF9')" class="link-pdf">{{
                          namePDF9
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload4-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">หนังสือข้อตกลงในการดำเนินการวิจัย
                      (RO01_2_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;font-size: 16px;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF11')" class="link-pdf">{{
                          namePDF11
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload5-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารรับรองโครงร่างการวิจัย จาก
                      CREC/YMID</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF14')" class="link-pdf">{{
                          namePDF14
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload6-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบรายการแก้ไขโครงร่างวิจัย (RF
                      02_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF6')" class="link-pdf">{{
                          namePDF6
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Upload7-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารแสดงผลการพิจารณา (RL
                      02_1_2563)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('namePDF13')" class="link-pdf">{{
                          namePDF13
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณาClean-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span
                      style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา
                      (RF 01_2563) (Clean Version)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('onHaveSubmitReportForConsiderClean')" class="link-pdf">{{
                          onHaveSubmitReportForConsiderClean
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณาHighlight-->
            <v-layout mt-6>
              <v-flex xs11 class="pl-6">
                <v-layout>
                  <v-flex shrink class="text-start">
                    <span
                      style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบรายงานการส่งโครงร่างวิจัยเพื่อพิจารณา
                      (RF 01_2563) (Highlight Version)</span>
                  </v-flex>
                </v-layout>
                <v-layout mt-4 class="pl-5">
                  <v-flex>
                    <v-layout>
                      <v-flex shrink pt-2 pr-4 style="text-align: left;">
                        <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                        </span>
                        <span @click="openPDF('onHaveSubmitReportForConsiderHighlight')" class="link-pdf">{{
                          onHaveSubmitReportForConsiderHighlight
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <!--Other Upload-->
            <v-layout mt-6>
              <v-flex py-6>
                <v-layout>
                  <v-flex shrink pb-6 style="text-align: left;font-weight: bold">
                    <span style="font-weight: bold;font-size: 16px;">11. เอกสารอื่นๆ
                    </span>
                    <span style="color: #CC3D45;font-size: 12px">*หมายเหตุ : อัพโหลดได้เฉพาะไฟล์นามสกุล PDF
                      เท่านั้น</span>
                  </v-flex>
                </v-layout>
                <!--แบบบันทึกข้อมูล (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบบันทึกข้อมูล (ถ้ามี) (Clean
                        Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHavedataRecordFromClean')" class="link-pdf">{{ onHavedataRecordFromClean
                        }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบบันทึกข้อมูล (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบบันทึกข้อมูล (ถ้ามี) (Highlight
                        Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHavedataRecordFromHighlight')" class="link-pdf">{{
                        onHavedataRecordFromHighlight }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)
                        (Clean
                        Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveQuestionnaireInterviewClean')" class="link-pdf">{{
                        onHaveQuestionnaireInterviewClean }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">แบบสอบถามหรือสัมภาษณ์ (ถ้ามี)
                        (Highlight Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="
                        openPDF('onHaveQuestionnaireInterviewHighlight')
                        " class="link-pdf">{{ onHaveQuestionnaireInterviewHighlight }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--สมุดบันทึก (diary) (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">สมุดบันทึก (diary) (ถ้ามี) (Clean
                        Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDiaryClean')" class="link-pdf">{{ onHaveDiaryClean }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--สมุดบันทึก (diary) (ถ้ามี)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">สมุดบันทึก (diary) (ถ้ามี)
                        (Highlight Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDiaryHighlight')" class="link-pdf">{{ onHaveDiaryHighlight }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา ภาษาไทย (Information sheet/consent)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span
                        style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย
                        /หนังสือแสดงเจตนา (Clean Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDocumentsExplainClean')" class="link-pdf">{{
                        onHaveDocumentsExplainClean }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย /หนังสือแสดงเจตนา ภาษาไทย (Information sheet/consent)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span
                        style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารชี้แจงข้อมูลผู้ร่วมโครงการวิจัย
                        /หนังสือแสดงเจตนา (Highlight Version)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveDocumentsExplainHighlight')" class="link-pdf">{{
                        onHaveDocumentsExplainHighlight }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--เอกสารอื่นๆ ได้แก่ โฆษณา สิ่งตีพิมพ์ บทความ สื่อ เช่น วิดีโอ ซีดี เทป-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">เอกสารอื่นๆ ได้แก่ โฆษณา
                        สิ่งตีพิมพ์
                        บทความ สื่อ เช่น
                        วิดีโอ ซีดี เทป</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveOtherDocuments2')" class="link-pdf">{{ onHaveOtherDocuments2
                        }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--สำเนาหนังสือรับรองว่า ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">สำเนาหนังสือรับรองว่า
                        ได้ผ่านการสอบโครงร่างการวิจัยจากคณะ /สถาบันแล้ว</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveCertificate2')" class="link-pdf">{{ onHaveCertificate2 }}</span>
                    </v-flex>
                  </v-layout>
                </div>
                <!--คู่มือผู้วิจัย (Investigator brochure)-->
                <div class="mb-8">
                  <v-layout>
                    <v-flex mb-2 pb-2 pl-8 style="text-align: left;">
                      <span style="font-weight: bold;font-size: 19px;color: #CC3D45;">คู่มือผู้วิจัย (Investigator
                        brochure)</span>
                    </v-flex>
                  </v-layout>
                  <v-layout pl-8>
                    <v-flex shrink pt-2 pr-4 style="text-align: left;">
                      <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด :
                      </span>
                      <span @click="openPDF('onHaveInvestigatorBrochure2')" class="link-pdf">{{
                        onHaveInvestigatorBrochure2 }}</span>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>

      <v-layout mt-10 px-12>
        <v-flex shrink style="text-align: left;font-weight: bold">
          <span style="font-weight: bold;font-size: 14px;color: #3e7662">
            เอกสารที่เกี่ยวข้องซึ่งคิดว่าอาจจะเป็นประโยชน์ในการพิจารณาโครงการวิจัย
          </span>
        </v-flex>
      </v-layout>
      <!-- Dynamic Fields -->
      <v-layout class="justify-center">
        <v-flex>
          <v-layout v-for="(item, i) in form.relatedDocuments" :key="i" mb-6 mt-6 class="justify-center">
            <v-flex xs5>
              <v-layout>
                <v-flex shrink mr-3 class="pt-2">
                  <span class="font-weight-bold">ชื่อเอกสาร TH</span>
                </v-flex>
                <v-flex>
                  <v-text-field prepend-icon="" v-model="item.name" dense color="#3E7662" hide-details></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex shrink mr-3 class="pt-2">
                  <span class="font-weight-bold">ชื่อเอกสาร EN</span>
                </v-flex>
                <v-flex>
                  <v-text-field prepend-icon="" v-model="item.name_en" dense color="#3E7662"
                    hide-details></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 pl-4>
              <v-layout class="justify-center">
                <v-flex shrink pt-2 pr-4 style="text-align: left;">
                  <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด : </span>
                  <span @click="openFilePDF(item.filePath)" class="link-pdf">{{
                    item.file
                  }}</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <!-- เอกสารโครงการ -->
      <div id="summary-file">
        <v-layout mt-10 px-12>
          <v-flex shrink style="text-align: left;font-weight: bold">
            <h2 style="font-weight: bold;color: #3e7662">
              เอกสารโครงการ
            </h2>
          </v-flex>
        </v-layout>
        <v-layout class="justify-center">
          <v-flex v-if="summaryFile.length > 0">
            <v-layout v-for="(item, i) in summaryFile" :key="i" mb-6 mt-6 class="justify-center">
              <v-flex xs10>
                <v-layout>
                  <v-flex shrink pt-2 pr-4 style="text-align: left;">
                    <span style="font-weight: bold">ชื่อไฟล์ที่อัพโหลด : </span>
                    <span @click="openFilePDF2(item.path)" class="link-pdf">{{
                      item.name
                      }}</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-else>
            <v-layout class="justify-center">
              <v-flex xs10>
                <v-layout>
                  <v-flex shrink pt-2 pr-4 style="text-align: left;">
                    <span style="font-weight: bold; color: gray">ไม่มีเอกสารโครงการ</span>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <v-divider class="mt-10"></v-divider>
      <v-layout class="pa-12">
        <v-flex style="text-align: left;">
          <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
        </v-flex>
        <v-flex style="text-align: right">
          <v-btn depressed v-if="user_role === 1 && isEdit" color="#3E7662" dark width="100px" @click="edit">
            <v-icon class="mr-3">edit</v-icon>
            <span>แก้ไข</span>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout class="pr-12 pb-12">
        <v-flex style="text-align: right">
          <v-btn depressed v-if="user_role === 1" color="red" width="100px" dark @click="onDelete">
            <v-icon class="mr-3">delete</v-icon>
            <span>ลบ</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <!-- End Form -->
    <!--        <v-layout class="text-end" mt-8>-->
    <!--            <v-flex>-->
    <!--                <v-btn class="mx-4 font-weight-bold" dark depressed  color="#3E7662" @click="$router.go(-1)">ย้อนกลับ</v-btn>-->
    <!--            </v-flex>-->
    <!--        </v-layout>-->

    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </v-content>
</template>

<script>
import TextareaForm from "../../../components/input/TextareaForm";
import TextfieldForm from "../../../components/input/TextfieldForm";
import DateInputForm from "../../../components/input/DateInputForm";
import TextAutocomplete from "../../../components/input/TextAutocomplete";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../../components/table/FormTable";
import { mapState } from "vuex";
export default {
  components: {
    FormTable,
    Loading,
    TextareaForm,
    TextfieldForm,
    DateInputForm,
    TextAutocomplete
  },
  data: () => ({
    isLoading: false,
    isEdit: false,
    fullPage: true,
    menu_date_start: false,
    menu_date_end: false,
    modal: false,
    isInside: "",
    namePDF1: "",
    namePDF2: "",
    namePDF3: "",
    namePDF4: "",
    namePDF5: "",
    namePDF6: "",
    namePDF7: "",
    namePDF8: "",
    namePDF9: "",
    namePDF10: "",
    namePDF11: "",
    namePDF12: "",
    namePDF13: "",
    namePDF14: "",
    linkPDF1: "",
    linkPDF2: "",
    linkPDF3: "",
    linkPDF4: "",
    linkPDF5: "",
    linkPDF6: "",
    linkPDF7: "",
    linkPDF8: "",
    linkPDF9: "",
    linkPDF10: "",
    linkPDF11: "",
    linkPDF12: "",
    linkPDF13: "",
    linkPDF14: "",
    placeHolder: "ผู้วิจัยหลัก",
    totalAmount: 0,
    form: {
      researchs: {
        thResearchName: "",
        enResearchName: "",
        field: "",
        startDate: "",
        endDate: "",
        version: "",
        researchPlace: "",
        researchPlaceEn: "",
        mainResearcherID: "",
        ymidtype: "",
        ymidname: "",
        checkboxInterestedGroup: {
          interested1: false,
          interested2: false,
          interested3: false,
          hasInterested3: "",
          interested4: false,
        },
        checkboxSampleGroup: {
          group1: false,
          group2: false,
          group3: false,
          group4: false,
          group5: false,
          group6: false,
          group7: false,
          group8: false,
          group9: false,
          group10: false,
        },
        educationType: "",
        otherEducationType: "",
        otherSampleGroup: "",
        budgetResourceID: "",
        budgetAmount: 0,
        ownerAmount: 0,
        compensationAmount: 0,
        otherAmount: 0,
        guarantyFile: "",
        guarantyNumber: "",
        researchFile: "",
        ro01_1File: "",
        ro01_2File: "",
        crecFile: "",
        editPointFile: "",
        researchcode: "",
        isManual: 0
      },
      dataRecordFrom: null,
      questionnaireInterview: null,
      diary: null,
      documentsExplain: null,
      otherDocuments: null,
      certificate: null,
      investigatorBrochure: null,
      researcherProfile: null,
      submitReportForConsider: null,
      researcherProfile2: null,
      submitReportForConsiderClean: null,
      submitReportForConsiderHighlight: null,
      documentsExplainClean: null,
      documentsExplainHighlight: null,
      relatedDocuments: [
        {
          name: "",
          file: null,
        },
      ],
    },
    onHavedataRecordFrom: "",
    onHaveQuestionnaireInterview: "",
    onHaveDiary: "",
    onHaveDocumentsExplain: "",
    onHaveOtherDocuments: "",
    onHaveCertificate: "",
    onHaveInvestigatorBrochure: "",
    onHaveResearcherProfile: "",
    onHaveSubmitReportForConsider: "",
    onHaveResearcherProfile2: "",
    onHaveSubmitReportForConsider2: "",
    onHaveSubmitReportForConsiderClean: "",
    onHaveSubmitReportForConsiderHighlight: "",
    onHaveDocumentsExplainClean: "",
    onHaveDocumentsExplainHighlight: "",
    onHaveDynamicFile: [],
    dateChange1: '',
    dateChange2: '',
    researchers: [
      {
        position: "ผู้วิจัยหลัก",
        userID: "",
        canManage: 1,
        historyFile: ""
      },
    ],
    researchersDelete: [],
    role: [],
    user_list: [],
    researcher_type: [
      {
        id: 1,
        type: "ผู้ร่วมวิจัย",
      },
      {
        id: 2,
        type: "ที่ปรึกษา",
      },
      {
        id: 3,
        type: "ผู้ประสานงาน",
      },
    ],
    budget_list: [],
    startDate: "",
    endDate: "",
    submissionType: "0",
    status: "",
    isInsideList: [
      {
        id: 0,
        name: "แหล่งทุนภายนอก",
      },
      {
        id: 1,
        name: "แหล่งทุนภายใน",
      },
    ],
    summaryFile: [],
  }),
  computed: {
    ...mapState({
      user_role: (state) => state.Auth.role,
    }),
  },
  created() {
    if (this.$route.query.logid) {
      this.getResearchLog(this.$route.query.logid);
    } else {
      if (!this.$route.query.id) {
        Swal.fire({
          icon: "warning",
          title: "ไม่พบงานวิจัย",
          confirmButtonColor: "#3E7662",
        }).then(() => {
          this.$router.go(-1);
        });
      } else {
        this.getFormResearch1();
      }
    }
    this.getUserList();
      this.getSummaryFile();
  },
  methods: {
    updateDataResearchers(value, index) {
      this.researchers[index].userID = value;
    },
    async getFormResearch1() {
      if (this.$route.query.id === "0") {
        console.log("Creating Research");
      } else {
        await this.$store
          .dispatch("Research/getFormResearch1", this.$route.query.id)
          .then((res) => {
            this.setData(res);
          });
      }
      await this.checkSubmission();
      this.isEdit = true;
    },
    async getResearchLog(logid) {
      await this.$store
        .dispatch("Research/getResearchLog", logid)
        .then((res) => {
          this.setData(res);
        });
      await this.checkSubmission();
      this.isEdit = false;
    },
    checkSubmission() {
      if (
        this.form.researchs.version > 1 ||
        this.status === "ปรับปรุงแก้ไขเพื่อรับรอง" ||
        this.status === "ปรับปรุงแก้ไขเพื่อพิจารณาใหม่"
      ) {
        this.submissionType = "1";
      } else if (
        this.form.researchs.version == 1 && this.form.researchs.isManual == 1
      ) {
        this.submissionType = "2";
      } else if (
        this.form.researchs.version == 1
      ) {
        this.submissionType = "0";
      } else {
        this.submissionType = "";
      }
    },
    uploadFileChange(fileName, e) {
      this.form.researchs[fileName] = e;
    },
    openFilePDF(link) {
      if (new Date(this.form.created_at) < new Date('2023-01')) {
        document.getElementById("summary-file").scrollIntoView();
      } else {
        window.open(link);
      }
    },
    openFilePDF2(link) {
      window.open(link);
    },
    openPDF(name, isDynamic = 0) {
      if (new Date(this.form.created_at) < new Date('2023-01')) {
        document.getElementById("summary-file").scrollIntoView();
      } else {
        if (isDynamic) {
          window.open(name)
        }
        if (name === "namePDF1") {
          window.open(this.linkPDF1);
        }
        if (name === "namePDF2") {
          window.open(this.linkPDF2);
        }
        if (name === "namePDF3") {
          window.open(this.linkPDF3);
        }
        if (name === "namePDF4") {
          window.open(this.linkPDF4);
        }
        if (name === "namePDF5") {
          window.open(this.linkPDF5);
        }
        if (name === "namePDF6") {
          window.open(this.linkPDF6);
        }
        if (name === "namePDF7") {
          window.open(this.linkPDF7);
        }
        if (name === "namePDF8") {
          window.open(this.linkPDF8);
        }
        if (name === "namePDF9") {
          window.open(this.linkPDF9);
        }
        if (name === "namePDF10") {
          window.open(this.linkPDF10);
        }
        if (name === "namePDF11") {
          window.open(this.linkPDF11);
        }
        if (name === "namePDF12") {
          window.open(this.linkPDF12);
        }
        if (name === "namePDF13") {
          window.open(this.linkPDF13);
        }
        if (name === "namePDF14") {
          window.open(this.linkPDF14);
        }
        if (name === "onHavedataRecordFrom") {
          window.open(this.linkPDF15);
        }
        if (name === "onHaveQuestionnaireInterview") {
          window.open(this.linkPDF16);
        }
        if (name === "onHaveDiary") {
          window.open(this.linkPDF17);
        }
        if (name === "onHaveDocumentsExplain") {
          window.open(this.linkPDF18);
        }
        if (name === "onHaveOtherDocuments") {
          window.open(this.linkPDF19);
        }
        if (name === "onHaveCertificate") {
          window.open(this.linkPDF20);
        }
        if (name === "onHaveInvestigatorBrochure") {
          window.open(this.linkPDF21);
        }
        if (name === "onHavedataRecordFromClean") {
          window.open(this.linkPDF22);
        }
        if (name === "onHaveQuestionnaireInterviewClean") {
          window.open(this.linkPDF23);
        }
        if (name === "onHaveDiaryClean") {
          window.open(this.linkPDF24);
        }
        if (name === "onHavedataRecordFromHighlight") {
          window.open(this.linkPDF25);
        }
        if (name === "onHaveQuestionnaireInterviewHighlight") {
          window.open(this.linkPDF26);
        }
        if (name === "onHaveDiaryHighlight") {
          window.open(this.linkPDF27);
        }
        if (name === "onHaveDocumentsExplainClean") {
          window.open(this.linkPDF28);
        }
        if (name === "onHaveOtherDocuments2") {
          window.open(this.linkPDF29);
        }
        if (name === "onHaveCertificate2") {
          window.open(this.linkPDF30);
        }
        if (name === "onHaveInvestigatorBrochure2") {
          window.open(this.linkPDF31);
        }
        if (name === "onHaveResearcherProfile") {
          window.open(this.linkPDF32);
        }
        if (name === "onHaveSubmitReportForConsider") {
          window.open(this.linkPDF33);
        }
        if (name === "onHaveResearcherProfile2") {
          window.open(this.linkPDF34);
        }
        if (name === "onHaveSubmitReportForConsider2") {
          window.open(this.linkPDF35);
        }
        if (name === "onHaveDocumentsExplainHighlight") {
          window.open(this.linkPDF36);
        }
        if (name === "onHaveSubmitReportForConsiderClean") {
          window.open(this.linkPDF37);
        }
        if (name === "onHaveSubmitReportForConsiderHighlight") {
          window.open(this.linkPDF38);
        }
      }
    },
    add(index) {
      this.researchers.push({ position: "", userID: "", canManage: 0, historyFile: '' });
      this.indexArr = parseInt(this.indexArr) + index;
    },
    remove(index) {
      var objs = {};
      objs = this.researchers.splice(index, 1);
      objs.forEach((obj) => {
        this.researchersDelete.push(obj);
      });
      this.indexArr = parseInt(this.indexArr) - 1;
    },
    onDelete() {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลงานวิจัยนี้ใช่หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("FormResearch/deleteResearch", this.$route.query.id)
            .then((res) => {
              this.isLoading = false;
              this.$router.push('/all-research')
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    edit() {
      Swal.fire({
        title: "คุณต้องการแก้ไขข้อมูลงานวิจัยนี้ใช่หรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form.researchs["researchers"] = this.researchers;
          this.form.researchs["ownerAmount"] = parseInt(this.form.researchs["ownerAmount"]);
          this.form.researchs["researchersDelete"] = this.researchersDelete;
          this.form["researchID"] = this.$route.query.id;
          this.$store
            .dispatch("FormResearch/editResearch", this.form)
            .then((res) => {
              this.isLoading = false;
              this.$router.push('/all-research')
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    // Get User List
    getUserList() {
      this.isLoading = true;
      this.$store.dispatch("Common/getUserList").then((res) => {
        res.all_researcher_data.forEach((data) => {
          this.user_list.push({
            user_id: data.id,
            user_name: data.thName,
          });
        });
        this.isLoading = false;
      });
    },
    // Get Budget List
    getBudgetList() {
      this.budget_list = [];
      this.isLoading = true;
      this.$store
        .dispatch("Common/getBudgetList", this.isInside)
        .then((res) => {
          res.forEach((data) => {
            this.budget_list.push({
              budget_id: data.id,
              budget_name: data.budgetResource,
            });
          });
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    findMatchingProvince(a, b) {
      return a == b;
    },
    updateDate(name, val) {
      if (name === "startDate") {
        this.form.researchs.startDate = val.date;
        this.dateChange1 = val.changeDate;
      }
      if (name === "endDate") {
        this.form.researchs.endDate = val.date;
        this.dateChange2 = val.changeDate;
      }
      this.$forceUpdate();
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);

      sub_year = parseInt(sub_year) + 543;

      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    updateDataResearchs(name, val) {
      this.form.researchs[name] = val;
      if (
        name === "otherAmount" ||
        name === "ownerAmount" ||
        name === "compensationAmount"
      ) {
        this.calculateTotalAmount();
      }
    },
    calculateTotalAmount() {
      this.totalAmount =
        parseInt(this.form.researchs.ownerAmount) +
        parseInt(this.form.researchs.compensationAmount) +
        parseInt(this.form.researchs.otherAmount);
    },
    clearTextField(name) {
      switch (name) {
        case "otherSampleGroup":
          this.form.researchs.otherSampleGroup = "";
          break;
        case "otherEducationType":
          this.form.researchs.otherEducationType = "";
          break;
        case "ownerAmount":
          this.form.researchs.checkboxInterestedGroup.interested4 = false;
          this.form.researchs.ownerAmount = 0;
          this.calculateTotalAmount();
          break;
        case "compensationAmount":
          this.form.researchs.checkboxInterestedGroup.interested4 = false;
          this.form.researchs.compensationAmount = 0;
          this.calculateTotalAmount();
          break;
        case "otherAmount":
          this.form.researchs.checkboxInterestedGroup.interested4 = false;
          this.form.researchs.checkboxInterestedGroup.hasInterested3 = "";
          this.form.researchs.otherAmount = 0;
          this.calculateTotalAmount();
          break;
        case "dontHaveAmount":
          if (this.form.researchs.checkboxInterestedGroup.interested4) {
            this.form.researchs.checkboxInterestedGroup.interested1 = false;
            this.form.researchs.checkboxInterestedGroup.interested2 = false;
            this.form.researchs.checkboxInterestedGroup.interested3 = false;
            this.form.researchs.checkboxInterestedGroup.hasInterested3 = "";
            this.form.researchs.ownerAmount = 0;
            this.form.researchs.compensationAmount = 0;
            this.form.researchs.otherAmount = 0;
            this.calculateTotalAmount();
          }
      }
    },
    async getSummaryFile() {
      let researchID = this.$route.query.id;
      await this.$store
        .dispatch("Research/getSummaryFile", researchID)
        .then((res) => {
          this.summaryFile = res?.result;
        });
    },
    async setData(res) {
      this.form.researchs.thResearchName = res.thResearchName;
      this.form.researchs.enResearchName = res.enResearchName;
      this.form.researchs.ymidtype = res.ymidtype ? res.ymidtype : "-";
      this.form.researchs.ymidname = res.ymidname ? res.ymidname : "-";
      this.form.researchs.version = res.version;
      this.form.researchs.protocolNumber =
        res.protocolNumber === "undefined" ? "-" : res.protocolNumber;
      this.status = res.status;
      this.form.researchs.mainResearcherID = res.userID;
      this.form.researchs.field = res.field;
      this.researchers[0].userID = res.userID;
      this.researchers[0].historyFilePath = res.researcherProfilePath;
      res.researcher_and_adviser.forEach((data) => {
        this.researchers.push({
          position: data.position,
          userID: data.userID,
          canManage: data.canManage,
          historyFile: data.historyFile,
          historyFilePath: data.historyFilePath
        });
      });
      this.form.researchs.startDate = res.startDate;
      this.startDate = res.startDate;
      this.dateChange1 = this.changeDate(res.startDate);
      this.form.researchs.endDate = res.endDate;
      this.endDate = res.endDate;
      this.dateChange2 = this.changeDate(res.endDate);
      this.form.researchs.researchPlace = res.researchPlace;
      this.form.researchs.researchPlaceEn = res.researchPlaceEn;
      if (res.checkboxInterestedGroup)
        this.form.researchs.checkboxInterestedGroup =
          res.checkboxInterestedGroup;
      if (res.checkboxSampleGroup)
        this.form.researchs.checkboxSampleGroup = res.checkboxSampleGroup;
      this.form.researchs.educationType = res.educationType;
      this.form.researchs.otherEducationType = res.otherEducationType;
      this.form.researchs.otherSampleGroup = res.otherSampleGroup;
      this.isInside = res.budget_resource
        ? res.budget_resource.isInside
        : "";
      if (this.isInside !== "" || this.isInside !== "undefined") {
        await this.getBudgetList();
      }
      this.form.researchs.budgetResourceID = res.budgetResourceID;
      this.form.researchs.budgetAmount = res.budgetAmount;
      this.form.researchs.ownerAmount = res.ownerAmount;
      this.form.researchs.compensationAmount = res.compensationAmount;
      this.form.researchs.otherAmount = res.otherAmount;
      this.form.researchs.guarantyFile = res.guarantyFile;
      this.form.researchs.guarantyNumber = res.guarantyNumber;
      this.form.researchs.researchFile = res.researchFile;
      this.form.researchs.ro01_1File = res.ro01_1File;
      this.form.researchs.ro01_2File = res.ro01_2File;
      this.form.researchs.crecFile = res.crecFile;
      this.form.researchs.editPointFile = res.editPointFile;
      this.form.researchs.researchFileClean = res.researchFileClean;
      this.form.researchs.researchFileHighlight =
        res.researchFileHighlight;
      this.form.researchs.ro01_1FileClean = res.ro01_1FileClean;
      this.form.researchs.ro01_1FileHighlight = res.ro01_1FileHighlight;
      this.form.researchs.ro01_2FileClean = res.ro01_2FileClean;
      this.form.researchs.ro01_2FileHighlight = res.ro01_2FileHighlight;
      this.form.researchs.considerResultFile = res.considerResultFile;
      this.form.researchs.crecFile2 = res.crecFile2;
      this.form.researchs.researchCode = res.researchCode;
      this.form.researchs.isManual = res.isManual;
      this.namePDF1 =
        res.guarantyFile &&
          res.guarantyFile !== undefined &&
          res.guarantyFile !== "undefined"
          ? res.guarantyFile
          : "";
      this.namePDF2 =
        res.researchFile &&
          res.researchFile !== undefined &&
          res.researchFile !== "undefined"
          ? res.researchFile
          : "";
      this.namePDF3 =
        res.ro01_1File &&
          res.ro01_1File !== undefined &&
          res.ro01_1File !== "undefined"
          ? res.ro01_1File
          : "";
      this.namePDF4 =
        res.ro01_2File &&
          res.ro01_2File !== undefined &&
          res.ro01_2File !== "undefined"
          ? res.ro01_2File
          : "";
      this.namePDF5 =
        res.crecFile &&
          res.crecFile !== undefined &&
          res.crecFile !== "undefined"
          ? res.crecFile
          : "";
      this.namePDF6 =
        res.editPointFile &&
          res.editPointFile !== undefined &&
          res.editPointFile !== "undefined"
          ? res.editPointFile
          : "";
      this.namePDF7 =
        res.researchFileClean &&
          res.researchFileClean !== undefined &&
          res.researchFileClean !== "undefined"
          ? res.researchFileClean
          : "";
      this.namePDF8 =
        res.researchFileHighlight &&
          res.researchFileHighlight !== undefined &&
          res.researchFileHighlight !== "undefined"
          ? res.researchFileHighlight
          : "";
      this.namePDF9 =
        res.ro01_1FileClean &&
          res.ro01_1FileClean !== undefined &&
          res.ro01_1FileClean !== "undefined"
          ? res.ro01_1FileClean
          : "";
      this.namePDF10 =
        res.ro01_1FileHighlight &&
          res.ro01_1FileHighlight !== undefined &&
          res.ro01_1FileHighlight !== "undefined"
          ? res.ro01_1FileHighlight
          : "";
      this.namePDF11 =
        res.ro01_2FileClean &&
          res.ro01_2FileClean !== undefined &&
          res.ro01_2FileClean !== "undefined"
          ? res.ro01_2FileClean
          : "";
      this.namePDF12 =
        res.ro01_2FileHighlight &&
          res.ro01_2FileHighlight !== undefined &&
          res.ro01_2FileHighlight !== "undefined"
          ? res.ro01_2FileHighlight
          : "";
      this.namePDF13 =
        res.considerResultFile &&
          res.considerResultFile !== undefined &&
          res.considerResultFile !== "undefined"
          ? res.considerResultFile
          : "";
      this.namePDF14 =
        res.crecFile2 &&
          res.crecFile2 !== undefined &&
          res.crecFile2 !== "undefined"
          ? res.crecFile2
          : "";
      this.linkPDF1 = res.guarantyFilePath;
      this.linkPDF2 = res.researchFilePath;
      this.linkPDF3 = res.ro01_1FilePath;
      this.linkPDF4 = res.ro01_2FilePath;
      this.linkPDF5 = res.crecFilePath;
      this.linkPDF6 = res.editPointFilePath;
      this.linkPDF7 = res.researchFileCleanPath;
      this.linkPDF8 = res.researchFileHighlightPath;
      this.linkPDF9 = res.ro01_1FileCleanPath;
      this.linkPDF10 = res.ro01_1FileHighlightPath;
      this.linkPDF11 = res.ro01_2FileCleanPath;
      this.linkPDF12 = res.ro01_2FileHighlightPath;
      this.linkPDF13 = res.considerResultFilePath;
      this.linkPDF14 = res.crecFile2Path;
      this.totalAmount =
        res.ownerAmount + res.compensationAmount + res.otherAmount;
      this.uploadFileChange(res.guarantyFile);
      this.uploadFileChange(res.researchFile);
      this.uploadFileChange(res.ro01_1File);
      this.uploadFileChange(res.ro01_2File);
      this.uploadFileChange(res.crecFile);
      this.uploadFileChange(res.editPointFile);

      this.form.dataRecordFrom = res.dataRecordFrom;
      this.form.questionnaireInterview = res.questionnaireInterview;
      this.form.diary = res.diary;
      this.form.documentsExplain = res.documentsExplain;
      this.form.otherDocuments = res.otherDocuments;
      this.form.certificate = res.certificate;
      this.form.investigatorBrochure = res.investigatorBrochure;
      this.form.relatedDocuments = res.relatedDocuments;
      this.form.created_at = res.created_at;
      this.linkPDF15 = res.dataRecordFromPath;
      this.linkPDF16 = res.questionnaireInterviewPath;
      this.linkPDF17 = res.diaryPath;
      this.linkPDF18 = res.documentsExplainPath;
      this.linkPDF19 = res.otherDocumentsPath;
      this.linkPDF20 = res.certificatePath;
      this.linkPDF21 = res.investigatorBrochurePath;
      this.linkPDF22 = res.dataRecordFromCleanPath;
      this.linkPDF23 = res.questionnaireInterviewCleanPath;
      this.linkPDF24 = res.diaryCleanPath;
      this.linkPDF25 = res.dataRecordFromHighlightPath;
      this.linkPDF26 = res.questionnaireInterviewHighlightPath;
      this.linkPDF27 = res.diaryHighlightPath;
      this.linkPDF28 = res.documentsExplainCleanPath;
      this.linkPDF29 = res.otherDocuments2Path;
      this.linkPDF30 = res.certificate2Path;
      this.linkPDF31 = res.investigatorBrochure2Path;
      this.linkPDF32 = res.researcherProfilePath;
      this.linkPDF33 = res.submitReportForConsiderPath;
      this.linkPDF34 = res.researcherProfile2Path;
      this.linkPDF35 = res.submitReportForConsider2Path;
      this.linkPDF36 = res.documentsExplainHighlightPath;
      this.linkPDF37 = res.submitReportForConsiderCleanPath;
      this.linkPDF38 = res.submitReportForConsiderHighlightPath;

      this.onHavedataRecordFrom = res.dataRecordFrom;
      this.onHaveQuestionnaireInterview = res.questionnaireInterview;
      this.onHaveDiary = res.diary;
      this.onHaveDocumentsExplain = res.documentsExplain;
      this.onHaveOtherDocuments = res.otherDocuments;
      this.onHaveCertificate = res.certificate;
      this.onHaveInvestigatorBrochure = res.investigatorBrochure;
      this.onHavedataRecordFromClean = res.dataRecordFromClean;
      this.onHaveQuestionnaireInterviewClean =
        res.questionnaireInterviewClean;
      this.onHaveDiaryClean = res.diaryClean;
      this.onHavedataRecordFromHighlight = res.dataRecordFromHighlight;
      this.onHaveQuestionnaireInterviewHighlight =
        res.questionnaireInterviewHighlight;
      this.onHaveDiaryHighlight = res.diaryHighlight;
      this.onHaveDocumentsExplainClean = res.documentsExplainClean;
      this.onHaveOtherDocuments2 = res.otherDocuments2;
      this.onHaveCertificate2 = res.certificate2;
      this.onHaveInvestigatorBrochure2 = res.investigatorBrochure2;
      this.onHaveResearcherProfile = res.researcherProfile;
      this.onHaveSubmitReportForConsider = res.submitReportForConsider;
      this.onHaveResearcherProfile2 = res.researcherProfile2;
      this.onHaveSubmitReportForConsider2 = res.submitReportForConsider2;
      this.onHaveSubmitReportForConsiderClean = res.submitReportForConsiderClean;
      this.onHaveSubmitReportForConsiderHighlight = res.submitReportForConsiderHighlight;
      this.onHaveDocumentsExplainHighlight = res.documentsExplainHighlight;
      this.form.relatedDocuments = res.relatedDocuments;
      if (res.relatedDocuments)
        res.relatedDocuments.forEach((data) => {
          this.onHaveDynamicFile.push({
            name: data.name,
            file: data.file ? data.file.substr(71) : '',
          });
        });
    }
  },
};
</script>

<style scoped>
.link-pdf:hover {
  cursor: pointer;
  color: #3e7662;
  font-weight: bold;
  text-decoration: underline;
}

/*.header-data-table {*/
/*    font-size: 20px;*/
/*}*/
/*.v-sheet {*/
/*     border-radius: 0!important;*/
/*}*/
</style>
